module.exports = __webpack_public_path__ + "static/img/9.8047e02.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/9/zh/9.png
// module id = Vr/A
// module chunks = 0